import React from "react";
import GuaranteedIcon from "@/assets/icons/guaranteed.svg";
import ManufacturerIcon from "@/assets/icons/manufacturer.svg";
import SupportIcon from "@/assets/icons/support.svg";
import FeatureBox from "@/components/feature-box/FeatureBox";
import OptionButton from "@/components/option-button/OptionButton";
import styles from "./screens.module.scss";

const getHref = next => `/guarantees-and-troubleshooting-guides?dt=guarantees-${next}`;

const GuaranteesScreen = () => {
  return (
    <div className={styles.container}>
      <h2>Why buy from John Lewis</h2>
      <div className={styles.esiContainer}>
        <div className={styles.featureRow}>
          <FeatureBox
            imgSrc={GuaranteedIcon.src}
            title="Guaranteed for longer"
            subTitle="Minimum 2 year guarantee now included on all electricals, 5 years on TVs. All at no extra cost."
          />
          <FeatureBox
            imgSrc={ManufacturerIcon.src}
            title="Manufacturer accredited repairs"
            subTitle="We only use repairers who are endorsed by us and manufacturers"
          />
          <FeatureBox
            imgSrc={SupportIcon.src}
            title="Flexible support options"
            subTitle="You can either speak to a partner in-store or view contact options online"
          />
        </div>
        <span>
          We also offer{" "}
          <a href="https://www.johnlewis.com/our-services/protect-plus">Protect Plus Accidental Damage Insurance</a> for
          extra peace of mind.{" "}
        </span>
        <div className={styles.divider} />
        <h2 className={styles.subTitle}>Select your product category to see Guarantee information & Exclusions</h2>
        <div className={styles.col}>
          <OptionButton title="Electricals, Technology & Lighting" href={getHref("electricals")} />
          <OptionButton title="Beds, Bedding, Sofas & Soft Furnishings" href={getHref("indoorFurniture")} />
          <OptionButton title="Cookware & Bathroom Fittings" href={getHref("cookware")} />
          <OptionButton title={"Pushchairs, Car Seats and Baby Electricals"} href={getHref("prams")} />
          <OptionButton title="Outdoor Furniture" href={getHref("outdoorFurniture")} />
          <OptionButton title="Luggage" href={getHref("luggage")} />
        </div>
      </div>
    </div>
  );
};

export default GuaranteesScreen;
